export default Summary;
import Base from "./Base";

const $ = jQuery;

function Summary( config ) {
    Base.call( this, config );
    var self = this;
    var placeHolderList;

    function render( placeholders ) {
        placeHolderList = placeholders;
    }

    return {
        render: render
    }
}

Summary.prototype = Object.create( Base.prototype );